import * as History from 'history';
import { IconChevronSmallLeft } from '@tock/icons';
import { Typography } from 'omakase';
import LockTimer from 'components/business/checkout/LockTimer';
import clsx from 'clsx';

interface RescheduleHeaderProps {
  location: History.Location;
  lockedUntilMs?: number;
  onClickBack(): void;
  onLockExpiration(): void;
  showOptions: boolean;
  subtitle: React.ReactNode;
  title: string;
}

const RescheduleHeader: React.FC<RescheduleHeaderProps> = ({
  location,
  lockedUntilMs,
  onClickBack,
  onLockExpiration,
  title,
  showOptions,
  subtitle,
}) => {
  const chooseTimeClassName = clsx('CheckoutHeader-step', {
    'is-active': location.pathname.indexOf('start') !== -1,
  });

  const optionsClassName = clsx('CheckoutHeader-step', {
    'is-active': location.pathname.indexOf('options') !== -1,
  });

  const confirmClassName = clsx('CheckoutHeader-step', {
    'is-active': location.pathname.indexOf('confirm') !== -1,
  });

  return (
    <div className="CheckoutHeader CheckoutHeader--reschedule">
      <div className="CheckoutHeader-primaryNav">
        <button className="CheckoutHeader-back" onClick={onClickBack}>
          <IconChevronSmallLeft className="CheckoutHeader-backIcon" />
        </button>
        <h1 className="CheckoutHeader-title">
          <Typography component="span" variant="heading02">
            {title}
          </Typography>
        </h1>
        <div className="CheckoutHeader-mobileTitle">
          <Typography color="inherit" component="span" variant="heading03">
            {title}
          </Typography>
        </div>
        <div className="CheckoutHeader-emptySpacer" />
      </div>

      <div className="CheckoutHeader-secondaryNav">
        <button className="CheckoutHeader-back" onClick={onClickBack}>
          <IconChevronSmallLeft className="CheckoutHeader-backIcon" />
        </button>

        <div className="CheckoutHeader-steps">
          <div data-testid="step-modify" className={chooseTimeClassName}>
            <Typography color="inherit" component="span" variant="body02">
              Modify reservation
            </Typography>
          </div>

          {showOptions && (
            <div data-testid="step-addon" className={optionsClassName}>
              <Typography color="inherit" component="span" variant="body02">
                Reselect add-ons
              </Typography>
            </div>
          )}

          <div data-testid="step-confirm" className={confirmClassName}>
            <Typography color="inherit" component="span" variant="body02">
              Confirm
            </Typography>
          </div>
        </div>

        {lockedUntilMs && (
          <LockTimer lockedUntilMs={lockedUntilMs} onLockExpiration={onLockExpiration} />
        )}
      </div>
      {subtitle ? <div className="CheckoutHeader-subtitle">{subtitle}</div> : null}
    </div>
  );
};

export default RescheduleHeader;
